/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreditCardGetResponseFromDiscriminatorValue, serializeCreditCardPatchRequest, type CreditCardGetResponse, type CreditCardPatchRequest } from '../../models';
// @ts-ignore
import { BalanceRequestBuilderRequestsMetadata, type BalanceRequestBuilder } from './balance';
// @ts-ignore
import { HistoryRequestBuilderRequestsMetadata, type HistoryRequestBuilder } from './history';
// @ts-ignore
import { PaymentRequestBuilderRequestsMetadata, type PaymentRequestBuilder } from './payment';
// @ts-ignore
import { PromotionalbalancesRequestBuilderRequestsMetadata, type PromotionalbalancesRequestBuilder } from './promotionalbalances';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/{creditCardId}
 */
export interface WithCreditCardItemRequestBuilder extends BaseRequestBuilder<WithCreditCardItemRequestBuilder> {
    /**
     * The balance property
     */
    get balance(): BalanceRequestBuilder;
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * The payment property
     */
    get payment(): PaymentRequestBuilder;
    /**
     * The promotionalbalances property
     */
    get promotionalbalances(): PromotionalbalancesRequestBuilder;
    /**
     * Deletes a credit card
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Retrieves a specific credit card
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreditCardGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreditCardGetResponse | undefined>;
    /**
     * Updates a credit card
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     patch(body: CreditCardPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Deletes a credit card
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Retrieves a specific credit card
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Updates a credit card
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: CreditCardPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCreditCardItemRequestBuilderUriTemplate = "{+baseurl}/creditcards/{creditCardId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCreditCardItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCreditCardItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    balance: {
        requestsMetadata: BalanceRequestBuilderRequestsMetadata,
    },
    history: {
        requestsMetadata: HistoryRequestBuilderRequestsMetadata,
    },
    payment: {
        requestsMetadata: PaymentRequestBuilderRequestsMetadata,
    },
    promotionalbalances: {
        requestsMetadata: PromotionalbalancesRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCreditCardItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCreditCardItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithCreditCardItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createCreditCardGetResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: WithCreditCardItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreditCardPatchRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
